/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeJobsGetJob } from "../../funcs/computeJobsGetJob.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetJobRequest$inboundSchema,
};

export const tool$computeJobsGetJob: ToolDefinition<typeof args> = {
  name: "compute-jobs-get-job",
  description: `Get a job`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeJobsGetJob(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
